module.exports = __webpack_public_path__ + "static/media/capstone_permissions.dc449005.yaml";